import React, { useEffect, useState, useRef } from "react";
import { checkInput } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import eye from "../../images/eye.svg";
import { NOT_EQUAL_EMAILS, TypeConfirm, TEXT_CHANGE_EMAIL, TITLE_CONFIRM } from "../../utils/constants";
import { getSetEmailForm, getRoutes } from "../../services/selectors";
import {
  SET_EMAIL_EDIT_CP, SET_EMAIL_EDIT_NE, SET_EMAIL_EDIT_RNE
} from "../../services/actions/set_email_actions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { SET_PORTAL_CONFIRM } from "../../services/actions/portal_actions";


const SetEmail = () => {

  const dispatch = useDispatch();

  const [statusCurrPassword, setStatusCurrPassword] = useState({});
  const [statusNewEmail, setStatusNewEmail] = useState({});
  const [statusReNewEmail, setStatusReNewEmail] = useState({});
  const [equalEmails, setEqualEmails] = useState(true);

  const [formValid, setFormValid] = useState(false);

  const refToCPInput = useRef(null);

  const {
    current_password, new_email, re_new_email
  } = useSelector(getSetEmailForm);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  const routes = useSelector(getRoutes);
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  const changeCurrPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusCurrPassword({ ...statusCurrPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_EMAIL_EDIT_CP, current_password: e.target.value });
  }
  const changeNewEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusNewEmail({ ...statusNewEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_EMAIL_EDIT_NE, new_email: e.target.value });
  }
  const changeReNewEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusReNewEmail({ ...statusReNewEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: SET_EMAIL_EDIT_RNE, re_new_email: e.target.value });
  }

  const changeVisibilityCP = () => {
    refToCPInput.current.type === 'password' ?
      refToCPInput.current.type = 'string' :
      refToCPInput.current.type = 'password';
  }

  useEffect(() => {
    setEqualEmails(new_email === re_new_email);
    const validCurrPassword = checkInput(current_password, 8, 64, 'password').valid;
    const validNewEmail = checkInput(new_email, 8, 64, 'email').valid;
    const validReNewEmail = checkInput(re_new_email, 8, 64, 'email').valid;

    setFormValid(
      validCurrPassword && validNewEmail &&
      validReNewEmail && equalEmails
    );
  }, [current_password, new_email, re_new_email, equalEmails]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      current_password,
      new_email: new_email.toLowerCase(),
      re_new_email: re_new_email.toLowerCase()
    }
    dispatch({
      type: SET_PORTAL_CONFIRM,
      title: TITLE_CONFIRM,
      text: TEXT_CHANGE_EMAIL,
      typeConfirm: TypeConfirm.ChangeEmail,
      data
    });
  }


  return (
    <form onSubmit={handleSubmit} className="form" noValidate>

      <label htmlFor="current_password" className="label_text">
        Существующий пароль <span style={{ color: 'red' }}>*</span>
        <input
          type="password"
          id="current_password" name="current_password"
          required={true}
          value={current_password || ''}
          onChange={changeCurrPassword}
          className="input input__password"
          ref={refToCPInput}
        />
        <img src={eye} className="eye"
          alt='visibility current password' onClick={changeVisibilityCP}
        />
        <p className="error">{statusCurrPassword?.text}</p>
      </label>

      <label htmlFor="new_email" className="label_text">
        Новый адрес электронной почты <span style={{ color: 'red' }}>*</span>
        <input
          type="new_email"
          id="new_email" name="new_email"
          required={true}
          value={new_email}
          onChange={changeNewEmail}
          className="input"
        />
        <p className="error">{statusNewEmail?.text}</p>
      </label>

      <label htmlFor="re_new_email" className="label_text">
        Новый адрес почты (ещё раз) <span style={{ color: 'red' }}>*</span>
        <input
          type="re_new_email"
          id="re_new_email" name="re_new_email"
          required={true}
          value={re_new_email}
          onChange={changeReNewEmail}
          className="input"
        />
        <p className="error">
          {statusReNewEmail?.text}
          {!equalEmails && NOT_EQUAL_EMAILS}
        </p>
      </label>
      <button type="submit"
        className={`button ${!formValid ? 'button_disabled' : ''}`}
        disabled={!formValid}
      >
        Сменить адрес почты
      </button>
    </form>
  );
};

export default SetEmail;
